angular
  .module 'filters'
  .filter 'fullDatetime', ->
    (input) ->
      if input
        moment(input).format('ddd, Do MMM, YYYY h:mma')
